export class TextSpeaker {
    audio = null

    createAudio(text) {

        this.audio = new Audio("https://api.vvhan.com/api/song?txt=" + text);
    }

    play() {
        if (!this.audio) {
            return
        }
        this.audio.play()
    }

    pause() {
        if (!this.audio) {
            return
        }
        this.audio.pause()
    }

    destroy() {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }

    }
}
